import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../context/User';

import { Button, Container, Dropdown, Icon, Menu, Segment } from 'semantic-ui-react';
import { API, getLogo, getSystemName, isAdmin, isMobile, showSuccess } from '../helpers';
import '../index.css';
// import { TopBar } from './PoixeTopBar';

// Header Buttons
let headerButtons = [
  {
    name: '渠道',
    to: '/channel',
    icon: 'sitemap',
    admin: true
  },
  // {
  //   name: '双11活动',
  //   to: '/cheap',
  //   icon: 'shopping bag'
  // },
  {
    name: '价格',
    to: '/pricing',
    icon: 'dollar',
  },
  {
    name: '文档',
    to: '/docs',
    icon: 'folder open outline',
  },
  {
    name: '聊天',
    to: '/chat',
    icon: 'comments'
  },
  {
    name: '令牌',
    to: '/token',
    icon: 'key'
  },
  {
    name: '兑换',
    to: '/redemption',
    icon: 'dollar sign',
    admin: true
  },
  {
    name: '充值',
    to: '/topup',
    icon: 'cart'
  },
  {
    name: '用户',
    to: '/user',
    icon: 'user',
    admin: true
  },
  {
    name: '日志',
    to: '/log',
    icon: 'book'
  },
  {
    name: '设置',
    to: '/setting',
    icon: 'setting'
  },
  {
    name: '合伙人计划',
    to: '/partnerplan',
    icon: 'yen sign'
  }
  // {
  //   name: '使用文档',
  //   to: '/about',
  //   icon: 'folder open outline'
  // },
  // {
  //   name: '系统状态',
  //   to: 'https://status.openkey.cloud/',
  //   icon: 'chart bar'
  // }
];
// add a new page... 1/4
// if (localStorage.getItem('chat_link')) {
//   headerButtons.splice(1, 0, {
//     name: '聊天',
//     to: '/chat',
//     icon: 'comments'
//   });
// }

const Header = () => {
  const [userState, userDispatch] = useContext(UserContext);
  let navigate = useNavigate();

  const [showSidebar, setShowSidebar] = useState(false);
  const systemName = getSystemName();
  const logo = getLogo();

  async function logout() {
    setShowSidebar(false);
    await API.get('/api/user/logout');
    showSuccess('注销成功!');
    userDispatch({ type: 'logout' });
    localStorage.removeItem('user');
    navigate('/login');
  }

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const renderButtons = (isMobile) => {
    return headerButtons.map((button) => {
      if (button.admin && !isAdmin()) return <></>;
      if (isMobile) {
        return (
          <Menu.Item
            onClick={() => {
              navigate(button.to);
              setShowSidebar(false);
            }}
          >
            {button.name}
          </Menu.Item>
        );
      }
      return (
        <Menu.Item key={button.name} as={Link} to={button.to}>
          <Icon name={button.icon} />
          {button.name}
        </Menu.Item>
      );
    });
  };

  if (isMobile()) {
    return (
      <>
        <Menu
          borderless
          size='large'
          style={
            showSidebar
              ? {
                borderBottom: 'none',
                marginBottom: '0',
                borderTop: 'none',
                height: '51px'
              }
              : { borderTop: 'none', height: '52px' }
          }
        >
          <Container>
            <Menu.Item as={Link} to='/'>
              <img
                src={logo}
                alt='logo'
                style={{ marginRight: '0.75em' }}
              />
              <div style={{ fontSize: '20px' }}>
                <b>{systemName}</b>
              </div>
            </Menu.Item>
            <Menu.Menu position='right'>
              <Menu.Item onClick={toggleSidebar}>
                <Icon name={showSidebar ? 'close' : 'sidebar'} />
              </Menu.Item>
            </Menu.Menu>
          </Container>
        </Menu>

        <TopBar />

        {showSidebar ? (
          <Segment style={{ marginTop: 0, borderTop: '0' }}>
            <Menu secondary vertical style={{ width: '100%', margin: 0 }}>
              {renderButtons(true)}
              <Menu.Item>
                {userState.user ? (
                  <Button onClick={logout}>注销</Button>
                ) : (
                  <>
                    <Button
                      onClick={() => {
                        setShowSidebar(false);
                        navigate('/login');
                      }}
                    >
                      登录
                    </Button>
                    <Button
                      onClick={() => {
                        setShowSidebar(false);
                        navigate('/register');
                      }}
                    >
                      注册
                    </Button>
                  </>
                )}
              </Menu.Item>
            </Menu>
          </Segment>
        ) : (
          <></>
        )}
      </>
    );
  }

  // gemini 设计
  // 顶部通栏 - 风格参考：Vercel / Shadcn / Apple
  const TopBar = () => (
    <a
      href="https://docs.poixe.com/cn/programs/migration-openkey"
      target="_blank"
      rel="noreferrer"
      style={{
        display: 'block', // 让整个 Bar 可点击
        width: '100%',
        background: '#09090b', // Shadcn 风格的深色 (Zinc 950)，比纯黑更有质感
        color: '#fafafa',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        textDecoration: 'none', // 去除默认下划线
        transition: 'background-color 0.2s ease', // 增加交互平滑度
      }}
      onMouseEnter={(e) => {
        // 鼠标悬停变亮一点点，体现交互感
        e.currentTarget.style.backgroundColor = '#18181b';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = '#09090b';
      }}
    >
      <Container
        style={{
          height: '36px', // 稍微收窄高度，显得更精致
          fontSize: '13px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center', // 内容居中，大气
        }}
      >
        {/* "NEW" 胶囊标签 - 视觉焦点 */}
        <span
          style={{
            backgroundColor: '#fff',
            color: '#000',
            padding: '1px 8px',
            borderRadius: '9999px',
            fontSize: '10px',
            fontWeight: '800',
            marginRight: '12px',
            letterSpacing: '0.5px',
            display: 'inline-block',
            lineHeight: '16px' // 垂直居中修正
          }}
        >
          NEW
        </span>

        {/* 文本内容 */}
        <span style={{ fontWeight: 500, letterSpacing: '0.2px', opacity: 0.9 }}>
          全新平台 <span style={{ fontWeight: 700 }}>Poixe AI</span> 现已上线，查看迁移计划
        </span>

        {/* 箭头图标 */}
        <Icon name='arrow right' style={{ marginLeft: '6px', fontSize: '12px', height: 'auto', opacity: 0.8 }} />
      </Container>
    </a>
  );

  return (
    <>
      <TopBar />

      <Menu borderless style={{ borderTop: 'none' }}>
        <Container>
          <Menu.Item as={Link} to='/' className={'hide-on-mobile'}>
            <img src={logo} alt='logo' style={{ marginRight: '0.75em' }} />
            <div style={{ fontSize: '20px' }}>
              <b>{systemName}</b>
            </div>
          </Menu.Item>
          {renderButtons(false)}
          <Menu.Menu position='right'>
            {userState.user ? (
              <Dropdown
                text={userState.user.username}
                pointing
                className='link item'
              >
                <Dropdown.Menu>
                  <Dropdown.Item onClick={logout}>注销</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Menu.Item
                name='登录'
                as={Link}
                to='/login'
                className='btn btn-link'
              />
            )}
          </Menu.Menu>
        </Container>
      </Menu>
    </>
  );
};

export default Header;
